import { createSelector } from "@reduxjs/toolkit";
export const selectDefaultShippingAddress = createSelector([(state) => { var _a; return (_a = state.checkout.addresses) !== null && _a !== void 0 ? _a : []; }, (state) => state.checkout.country], (addresses, country) => {
    const defaultAddress = addresses.data.find((address) => address.isDefaultShipping);
    if (!defaultAddress) {
        return undefined;
    }
    return Object.assign(Object.assign({}, defaultAddress), country);
});
//# sourceMappingURL=selectDefaultShippingAddress.js.map